import { ReactNode } from "react"
import { AppShell } from "@/components/app-shell"
import type { BreadcrumbItem } from "@/types"

interface AppLayoutProps {
  children: ReactNode
  // Pages declare breadcrumbs; this layout variant renders the sidebar shell
  // and intentionally does not display a breadcrumb bar.
  breadcrumbs?: BreadcrumbItem[]
}

export function AppLayout({ children }: AppLayoutProps) {
  return <AppShell>{children}</AppShell>
}
